var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "breadcrumb"]
var __target

module.exports = function description (model) {
var el = model
  model = model.model
elementOpen("ol", "f6849b86-8798-4e24-84c5-abac39c32667", hoisted1)
  __target = model.crumbs
  if (__target) {
    ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
      var crumb = $value
      var $key = "acc0d3b0-e331-4aa7-9491-0b7ff744501c_" + $item
      elementOpen("li", $key, null, "class", model.isLast(crumb) ? 'active' : '')
        if (model.isFirst(crumb)) {
          elementOpen("a", null, null, "onclick", function ($event) {
            var $element = this;
          el.onclickcrumb && el.onclickcrumb(crumb)})
            if (model.icon) {
              elementOpen("i", null, null, "class", "fa fa-" + (model.icon) + "")
              elementClose("i")
            }
            text(" " + (crumb.text || '') + " \
                  ")
          elementClose("a")
        } else if (model.isLast(crumb)) {
          text(" \
                " + (crumb.text) + " \
              ")
        } else {
          elementOpen("a", null, null, "onclick", function ($event) {
            var $element = this;
          el.onclickcrumb && el.onclickcrumb(crumb)})
            text(" " + (crumb.text) + "")
          elementClose("a")
        }
      elementClose("li")
    }, this)
  }
elementClose("ol")
}
